export const fromApi = raw => ({
  id: Number(raw.id),
  name: raw.name || '',
  fileName: raw.file_name || raw.fileName || '',
  fileType: raw.content_type || raw.fileType || '',
  size: Number(raw.byte_size ?? raw.size) || 0,
  status: raw.status || 'pending',
  editable: Boolean(raw.editable),
  errorMessage: raw.error_message || raw.errorMessage || '',
  createdAt: raw.created_at || raw.createdAt || new Date().toISOString(),
});

export const isProcessing = document =>
  document.status === 'pending' || document.status === 'processing';
